(function() {
    'use strict';

    angular
        .module('appback')
        .directive('stringToNumber', stringToNumber);

    function stringToNumber() {
        var directive = {
            restrict: 'A',
            require: 'ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, ngModel) {
            ngModel.$parsers.push(function(value) {
                console.log('stringToNumber directive loaded', value);
                if (value === null || value === undefined || value === '') {
                    return null;
                }
                // Reemplaza la coma decimal por un punto para un parseo correcto
                var cleanValue = String(value).replace(',', '.');
                var parsedValue = parseFloat(cleanValue);
                return isNaN(parsedValue)? null : parsedValue;
            });

            ngModel.$formatters.push(function(value) {
                if (value === null || value === undefined || value === '' || isNaN(value)) {
                    return '';
                }
                // Al formatear para la vista, puedes decidir si quieres usar coma o punto.
                // Usar String() es seguro para mostrarlo en el input.
                return String(value).replace('.', ',');
            });
        }
    }
})();